<template>
    <div class="row">
        <div class=" col-lg-2 col-md-3 col-sm-12">
            <!-- Profile Image -->
            <div class="card card-info card-outline">
                <div class="card-body box-profile">
                    <div class="text-center">
                        <img style="width: 175px;" class="profile-user-img img-fluid img-circle" :src="img" alt="User profile picture">
                    </div>

                    <div v-if="shortDetail">
                        <h3 class="profile-username text-center">{{shortDetail.Name}}</h3> 
                        <ul class="list-group list-group-unbordered">
                            <li class="list-group-item">
                                <b>Contact</b> <br /> <a>{{shortDetail.Contact}}</a>
                            </li>
                            <li class="list-group-item">
                                <b>Email</b> <br /> <a>{{shortDetail.Email}}</a>
                            </li> 
                        </ul>
                    </div>
                </div>
                <!-- /.card-body -->
            </div>
            <!-- /.card -->
            <!-- About Me Box -->
            <!-- /.card -->
        </div>
        <!-- /.col -->
        <div class=" col-lg-10 col-md-9 col-sm-12">
            <div class="card">
                <div class="card-header p-2">
                    <ul class="nav nav-pills">
                        <li class="nav-item"><a class="nav-link active" href="#activity" data-toggle="tab" v-on:click="currentTab = 'profile'">Profile</a></li>
                        <li class="nav-item" v-if="shortDetail"><a class="nav-link" href="#" data-toggle="tab" v-on:click="currentTab = 'contact'">Contact & Address</a></li>
                        <li class="nav-item" v-if="shortDetail"><a class="nav-link" href="#" data-toggle="tab" v-on:click="currentTab = 'education'">Education</a></li>
                        <li class="nav-item" v-if="shortDetail"><a class="nav-link" href="#" data-toggle="tab" v-on:click="currentTab = 'experience'">Employment History</a></li>
                        <li class="nav-item" v-if="shortDetail"><a class="nav-link" href="#" data-toggle="tab" v-on:click="currentTab = 'research'">Research Publications</a></li> 
                        <li class="nav-item" v-if="shortDetail"><a class="nav-link" href="#" data-toggle="tab" v-on:click="currentTab = 'document'">Documents</a></li>
                        <li class="nav-item" v-if="shortDetail"><a class="nav-link" href="#" data-toggle="tab" v-on:click="currentTab = 'reference'">Reference</a></li>
                        <li class="nav-item" v-if="shortDetail"><a class="nav-link" href="#" data-toggle="tab" v-on:click="currentTab = 'eassy'">Essay</a></li>
                        <li class="nav-item" v-if="shortDetail && showStatusTab"><a class="nav-link" href="#" data-toggle="tab" v-on:click="currentTab = 'status'">Status</a></li>
                    </ul>
                </div><!-- /.card-header -->

                <component :is="currentTab" :send-emp="getEmpDetail" :send-img="getImg" :employee-id=id></component>

            </div>
            <!-- /.card -->
        </div>
        <!-- /.col -->
    </div>
</template>

<script>
    //
    import employeeProfile from './applicantProfile.vue';
    import employeeContact from './applicantContact.vue'; 
    import employeeEducation from './applicantEducation.vue'; 
    import employeeDocument from './applicantDocument.vue';
    import employeeResearch from './applicantResearch.vue';
    import employeeExperience from './applicantExperience.vue';
    import applicantReference from './applicantReference.vue';
    import applicantEassy from './applicantEassy.vue';
    import applicantStatus from './applicantStatus.vue';

    export default ({
        data() {
            return {
                id: 0,
                activeTab: 1,
                currentTab: 'profile',
                //emp: { Name: 'Hamza', EmpCode: 100, Contact: '', Email: ''}
                shortDetail: null,
                img: '/dist/icon-profile.png',
                showStatusTab: false,
                //../../../../wwwroot/Images/icon-profile.png
            }
        },
        components: {
            'profile': employeeProfile,
            'contact': employeeContact, 
            'education': employeeEducation,
            'document': employeeDocument,
            'research': employeeResearch,
            'experience': employeeExperience,
            'reference': applicantReference,
            'eassy': applicantEassy,
            'status': applicantStatus,
        },
        created: function () {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams) {
                this.id = Number(urlParams.get('id')); 
                var uri = window.location.toString();
                if (uri.indexOf("?") > 0) {
                    var clean_uri = uri.substring(0, uri.indexOf("?"));
                    window.history.replaceState({}, document.title, clean_uri);
                }

                if (window.location.href.toString().includes('EditJobApplication'))
                    this.showStatusTab = true;
            }

        },
        methods: {
            getEmpDetail(data) {
                this.shortDetail = data;
                if (this.shortDetail)
                    this.id = this.shortDetail.id;
                else
                    this.id = 0;
            },

            getImg(data) {
                if (data)
                    this.img = data;
                else
                    this.img = '/dist/icon-profile.png';
            },

            save() {
                $('#profile').submit();
            }
        }
    })</script>

<style scoped>
    .nav-tabs.flex-column .nav-item.show .nav-link, .nav-tabs.flex-column .nav-link.active {
        border-left: 3px solid #17a2b8;
    }

    .nav-item active {
        background-color: #17a2b8
    }

    .list-group-item {
        padding: 2px 0px;
    }

    .profile-username {
        font-size: 20px;
        margin-top: 5px;
    }

    .nav-link {
        font-weight: 600;
    }
</style>



// WEBPACK FOOTER //
// src/components/applicantCreate.vue